import React, { useEffect, useState } from 'react';
import { Button } from 'components/ui/button';
import { Modal } from 'react-bootstrap-5';

import { fetchImportStatus } from '../../../helpers/prospect_api';
import LoadingBar from './loading_bar';
import type { CallListImportStatus } from 'bundles/connect/types';

type Props = {
  handleClose: () => void;
  importId: number;
  setCallListData: React.Dispatch<React.SetStateAction<CallListImportStatus>>;
  setCallListId: React.Dispatch<React.SetStateAction<number>>;
}

export default function ImportModalUploading({
  handleClose,
  importId,
  setCallListData,
  setCallListId,
}: Props) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(async () => {
      const data = await fetchImportStatus(importId);
      setProgress(data.progress);

      if (data.callListId !== undefined) {
        clearInterval(interval);
        setCallListId(data.callListId);
        setCallListData(data);
      }
    }, 2500);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Modal.Header className="flex-row" closeButton>
        <Modal.Title as="h5">Uploading...</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          We will upload and prepare this list for you.
          Feel free to close this dialog as this will continue to be worked on in the background.
        </p>
        <LoadingBar progress={progress} />
      </Modal.Body>
      <Modal.Footer>
        <Button label="Close" variant="ghost" onClick={handleClose} />
      </Modal.Footer>
    </>
  );
}
